<template>
  <div>
    <img
      class="header-img"
      src="@/assets/images/home-header-top.png"
    >
  </div>
</template>

<script>
export default {
  name: "HomeHeader",
};
</script>

<style lang="stylus" scoped>
.header-img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Header.vue